export default {
  common: {
    lockerTitle: 'Locked',
    fromDate: 'From Date {0}',
    toDate: 'To Date {0}',
    searchPlaceHolder: 'Enter search text',
    searchColumn: 'Search Column',
    searchTypePlaceHolder: 'Search by',
    showing: 'Showing',
    of: 'of',
    conditionSearch: {
      findbyDirection: 'Find by direction',
      findbySender: 'Find by Sender',
      findbyReceiver: 'Find by Receiver',
      findbyMessage: 'Find by Message',
      findbyPID: 'Find by ProcessID',
      findbyMessageReference: 'Find by Message Reference',
      findbyPartner: 'Find by Partner',
      selectStatus: 'Status',
      findbyEDIID: 'Find by EDI ID',
      selectCompanyPartner: 'Company/Partner',
      selectLog: 'Log Type',
      nothingtofix: 'Nothing to fix',
      mapper: 'Mapper',
      findbyMapperName: 'Find by Mapper Name',
      findbyDBMapperName: 'Find by DB Mapper Name',
      selectType: 'Select Type',
      selectLocked: 'Select Locked',
      mapperName: 'Mapper Name',
      findbyFolderName: 'Find by Folder Name',
      findbyFileName: 'Find by File Name',
      selectSearchItem: 'Select Search Item',
      findbyCodeGroup: 'Find by Code Group',
      findbyDBBroker: 'Find by DB Broker name',
      findbyCodeName: 'Find by Code Name',
      findbySourceCode: 'Find by Source Code',
      findbyTargetCode: 'Find by Target Code',
      findbyName: 'Find by Name',
      findbySetupID: 'Find by Setup ID',
      findbyProcessID: 'Find by process ID',
      selectLogLevel: 'Log Level',
      selectPartner: 'Partner',
      selectSender: 'Sender',
      selectReceiver: 'Receiver',
      selectDirection: 'Direction',
      selectMessage: 'Message',
      selectCompanyEDIID: 'Company EDI',
      selectPartnerEDIID: 'Partner EDI',
      selectSenderEDIID: 'Sender ID',
      selectReceiverEDIID: 'Receiver ID',
      findbyMessageName: 'Find by Message Name',
      findbyLayoutName: 'Find by Layout Name',
      selectBusinessName: 'Select Business Name',
      findbyMappingDefinitionName: 'Find by Mapping Definition Name',
      selectMapperName: 'Select Mapper Name',
      selectDocumentType: 'Select Document Type',
      selectCustomer: 'Select Customer',
      findbyUserID: 'Find by User ID',
      findbyUserName: 'Find by User Name',
      selectCompany: 'Company',
      selectRole: 'Select Role',
      selectSetUpName: 'Setup Name',
      selectSearchKey: 'Search Key',
      inputSearchKey: 'Input Search Key',
      SearchKeyItem: 'Search Key Item',
      findbyDesc: 'Find by Description',
      findbyStCd: 'Find by Site Code',
      dateType: 'Date Type',
      all: 'All',
      userID: 'User ID',
      mqName: 'MQ Name',
      connectorEndPoint: 'Connector End Point',
      aiEndPoint: 'AI End Point',
      componentName: 'Component Name',
      componentType: 'Component Type',
      communicationType: 'Connector Type',
      search: 'Search',
      messageCode: 'Message Code',
      protocol: 'Protocol',
      activation: 'Activation',
      converterType: 'Converter Type',
      converterPattern: 'Converter Pattern',
      filterType: 'Filter Type',
      filterPattern: 'Filter Pattern',
      type: 'Type',
      additionalInformation: 'Additional information',
      findBySQLGroupName: 'Find By SQL Group Name',
      findByUserComponentName: 'Find By User Component Name',
    },
    characterSet: 'Character Set',
  },
  dashboard: {
    transtCount: 'Transaction count by ',
    partners: '{0} (Top 10)',
    message: 'Message (Top 10)',
    edi: 'EDI File Upload',
    repo: 'Repository Matching',
    transts: 'Transaction Status',
    success: 'Success',
    process: 'Processing',
    err: 'Error',
    trans: 'Abnormal Transactions',
  },
  fileViewPop: {
    selectCharSet: 'Character Set',
    copyToClipboard: 'Copy to Clipboard',
    sourceDataPath: 'Source Data Path',
    targetDataPath: 'Target Data Path',
  },
  mapBuilder: {
    pageHeader: 'Map Builder',
    ediType: 'Type',
    scannerInputFileTitle: 'Input Data',
    scannerTitle: 'Scanner',
    scannerOutputFileTitle: 'Biz Data',
    resultTitle: 'Result of compile or execution',
    mapperInputFileTitle: 'Biz Data',
    mapperTitle: 'Mapper',
    mapperOutputFileTitle: 'Output Data',
    loadFile: {
      loadFileHeader: 'Load File',
      saveFileHeader: 'Save File',
      folderSection: 'Folders',
      fileSection: 'Files',
      fileName: 'File Name',
      searchFieldPlaceHolder: 'Find by File Name',
      searchFolderPlaceHolder: 'Find by Folder Name',
      searchTypePlaceHolder: 'Search by',
      contextMenu: {
        rename: 'Rename',
        delete: 'Delete',
        move: 'Move',
        copy: 'Copy',
        refresh: 'Refresh',
      },
    },
    scannerList: {
      scannerListHeader: 'Scanner List',
      customerSearchTitle: 'Customer',
    },
    mapperList: {
      mapperListHeader: 'Mapper List',
      customerSearchTitle: 'Customer',
    },
    tableVersionHistory: {
      scanner: 'Scanner Version History',
      mapper: 'Mapper Version History',
    },
    builderCheckIn: {
      scannerCheckInHeader: 'Scanner Check In',
      mapperCheckInHeader: 'Mapper Check In',
      mapName: 'Map Name',
      scannerName: 'Scanner Name',
      mapperName: 'Mapper Name',
      comment: 'Comment',
      codeCovertingTable: 'Code Converting Table',
    },
    selectCodeTable: {
      selectCodeTableHeader: 'Select Code Table',
    },
  },
  codetable: {
    pageHeader: 'Code Tables',
    checkboxLabel: 'All code',
    codeLabelInfo: 'all codes are displayed regardless of left selected code',
    viewTotal: 'Show {0} / {1}',
    totalCount: 'Total Count : <span style="color: #497DDE">{0}</span>',
    addCodeDialog: {
      pageHeaderAdd: 'Add Code Group',
      pageHeaderModify: 'Modify Code Group',
      codeGroupName: 'Code Group Name',
    },
    codeDataPool: {
      pageHeader: 'Code Data Pool',
      groupCodePlaceHolder: 'Code Name',
      sourceCodePlaceHolder: 'Source Code',
      targetCodePlaceHolder: 'Target Code',
    },
  },
  dbBroker: {
    pageHeader: 'DB Broker Search',
    checkboxLabel: 'All Queries',
    codeLabelInfo: 'all queries are displayed regardless of left selected code',
    // viewTotal: "Show {0} / {1}",
    totalCount: 'Total Count : {0}',
    addDBBrokerDialog: {
      pageHeaderAdd: 'Add DB Broker',
      pageHeaderModify: 'Modify DB Broker',
      codeDBBrokerName: 'DB Broker Name',
      conditionSearch: {
        queryName: 'Query Name',
        dbName: 'DB Name',
        type: 'Type',
        queryText: 'Query Text',
      },
      tooltipQuerySeq: 'This number is the query execution order.',
    },
    queryNm: 'Query Name',
    queryTxt: 'Query Text',
    queryPool: {
      pageHeader: 'Query Pool',
    },
  },
  mapManager: {
    pageHeader: 'Mapper',
    updateDate: 'Update Date',
    mappingDefinitionList: 'Mapping Definition List',
    mapLayout: {
      addMap: 'Add Mapper',
      modifyMap: 'Modify Mapper',
      mapName: 'Map Name',
      mapType: 'Map Type',
      to: 'To',
      message: 'Message',
      ediVersion: 'EDI Version',
      mapperFile: 'Mapper File',
      comment: 'Comment',
      scannerFile: 'Scanner File',
      flatFileLayout: 'FlatFile Layout',
      mappingDefinition: 'Mapping Definition',
    },
    mapperVersionHistory: {
      header: 'Mapper Version History',
      mapperCheckIn: {
        header: 'Mapper Check In',
        mapName: 'Map Name',
        mapperName: 'Mapper Name',
        comment: 'Comment',
      },
    },
    scannerVersionHistory: {
      header: 'Scanner Version History',
      scannerCheckIn: {
        header: 'Scanner Check In',
        mapName: 'Map Name',
        scannerName: 'Scanner Name',
        comment: 'Comment',
      },
    },
  },
  mappingDefinition: {
    page_header: 'Mapping Definition',
    updateDate: 'Update Date',
    searchText: {
      searchAll: 'Search by',
      mappingDefinitionName: 'Mapping Definition Name',
      mapName: 'Mapper Name',
      version: 'Version',
      customer: 'Customer',
      updateDate: 'Update Date',
      updateUser: 'Update User',
    },
    mappingDefinitionVersionHistory: {
      pageHeader: 'Mapping Definition Version History',
    },
    mappingDefinitionCheckIn: {
      pageHeader: 'Mapping Definition Check In',
      mappingDefinition: 'Mapping Definition',
      comment: 'Comment',
    },
  },
  referenceFiles: {
    page_header: 'Reference Files',
    updateDate: 'Update Date',
    CustomerPlaceHolder: 'Customer',
    FileNamePlaceHolder: 'File Name',
    DocTypePlaceHolder: 'Doc Type',
    addReferenceFile: {
      pageHeader: 'Add Reference File',
      viewPdfFile: 'View Pdf File',
      fileName: 'File Name',
      docType: 'Type',
      comment: 'Comment',
    },
    searchText: {
      searchAll: 'Search by',
      fileName: 'Map Name',
      docType: 'Doc Type',
      comment: 'Comment',
      customer: 'Customer',
      updateDate: 'Update Date',
      updateUser: 'Update User',
    },
    modifyReferenceFile: {
      pageHeader: 'Modify Reference File',
    },
  },
  customerDataAnalysis: {
    page_header: 'Data Analysis',
    EDIFileUpload: 'EDI File Upload',
    mergeView: 'Merge View',
    EDIFileUploadPopUp: {
      page_header: 'EDI File Upload',
      addEdiFile: 'Add EDI File',
      fileFormat: 'File Format',
    },
  },
  repositoryMatching: {
    page_header: 'Repository Matching',
    EDIFileUpload: 'EDI File Upload',
    matchedMapListDialog: {
      page_header: 'Matched Mapper List',
    },
  },
  srmListManagement: {
    page_header: 'Interface List',
    findbySender: 'Find by Sender',
    findbyReceiver: 'Find by Receiver',
    findbyMessage: 'Find by Message',
    searchColumn: 'Search Column',
    referenceFiles: {
      page_header: 'Reference Files',
    },
    mapperList: {
      page_header: 'Mapper List',
    },
    referenceFilesList: {
      page_header: 'Reference File List',
    },
  },
  developmentResourcesManagement: {},
  membership: {},
  company: {
    addModiCompanyPop: {
      add_page_header: 'Add Company',
      modify_page_header: 'Modify Company',
    },
    companyInfo: 'Company Information',
    companyId: 'Company ID',
    companyName: 'Company Name',
    contactPerson: 'Contact Person',
    emailAddress: 'Email Address',
    save: 'Save',
    close: 'Close',
  },
  monitoring: {
    page_header: 'Transaction Log',
    uploadFileViewPop: {
      page_header: 'Processed File',
    },
    bizFileViewPop: {
      page_header: 'Biz. File',
    },
  },
  partners: {
    page_header: 'Partners',
    addModiPartnerPop: {
      add_page_header: 'Add Partner',
      modify_page_header: 'Modify Partner',
    },
    enterTheName: 'Enter the name',
    contactPersonName: 'Contact Person Name',
    emailAddress: 'Email Address',
    internalUse: 'Internal Use',
    partyCode: 'Party Code',
    remark: 'Remark',
    partnerId: 'Partner ID',
    partnerName: 'Partner Name',
    addPartner: 'Add Partner',
    addAnotherPartner: 'Add another partner',
    partnerInfo: 'Partner Information',
    save: 'Save',
    close: 'Close',
    company: 'Company',
  },
  identification: {
    page_header: 'Identification',
    qualifier: 'Qual.',
    ediID: 'ID',
    remark: 'Remark',
    ediInfo: 'EDI Identification',
    company: 'Company ID',
    partner: 'Partner ID',
    ediSR: 'Sender/Recipient ID',
    qual: 'Qualifier',
    type: 'Type',
  },
  communications: {
    page_header: 'Connectors',
    ftps: 'FTP(S)',
    ftp: 'FTP',
    smtp: 'SMTP',
    imap: 'IMAP',
    pop3: 'POP3',
    restApi: 'REST API',
    mq: 'MQ',
    soapApi: 'SOAP',
    http: 'HTTP',
    getFileNmPttn: 'Get Filename Pattern',
    putFileNmPttn: 'Put File Name Pattern',
    validMaxPattern: 'Max 5 item',
    validDuplicatePattern: 'Duplicate Pattern',
    exeInterval: 'Execution Interval',
    authType: 'Authorization Type',
    uri: 'URI',
    api: 'API Key',
    httpRecommend: 'We recommend below format sender-send-msg-to-receiver',
    httpEx: 'ex)smartlink-send-booking-to-allegro',
    emailFld: 'Email Folder',
    dataPart: 'Data Part to process',
    emailBody: 'Email Body',
    attachmentFile: 'Attachment File',
    both: 'Both',
    selfCert: 'Allow Self Signed Cert',
    maxRetryAttempts: 'Maximum Retry Attempts',
    senderEmail: 'Sender Email Address',
    recepientEmail: 'Recepient Email Address',
  },
  converters: {
    page_header: 'Converters',
    info: 'Information',
    partnerInfo: 'Converter Information',
    ediInfo: 'Additional Information',
    converterName: 'Converter Name',
    save: 'Save',
    close: 'Close',
    converterType: 'Converter Type',
    replacePttn: 'Replace pattern',
    maxFileName: 'Max length of file name',
    cutFileName: 'Cut type of file name',
    numSkip: 'Number of lines to skip',
    numRepeat: 'Number of lines to repeat',
    splitPttn: 'Split pattern',
    dbBroker: 'DB Broker',
    type: 'Type',
  },
  aiClient: {
    pageHeader: 'AI Client',
    aiClient: 'AI Client',
    aiClientName: 'Name',
    type: 'Type',
    apiEndpoint: 'API Endpoint',
    apiFormData: 'API Form Data',
    apiHeader: 'API Header',
    dataPathOfAPIResult: 'Data Path of Result',
  },
  filters: {
    pageHeader: 'Filters',
    filter: 'Filter',
    filterName: 'Filter Name',
    filterType: 'Filter Type',
    filterPattern: 'Pattern',
  },
  processSetup: {
    page_header: 'Workflow',
    addProcess: {
      findbyName: 'Enter the Name',
      modifyWorkflow: 'Modify Workflow',
      addWorkflow: 'Add Workflow',
      partner: 'Partner :',
      direction: 'Direction :',
      dropComponent: 'Drag & Drop component here.',
      expandAll: 'Expand All',
      collapseAll: 'Collapse All',
      route: 'Please check Workflow again !',
      addIdByMapper: 'Add ID By Mapper',
      applyHistory: {
        header: 'WorkFlow Apply History',
        workflowName: 'WorkFlow Name',
        workflowId: 'WorkFlow ID',
        comment: 'Comment',
      },
    },
    mini: 'Mini View',
    mapper_edi_sender: 'Sender',
    mapper_edi_receipt: 'Receiver',
    mapper_edi_specific: 'Use specific EDI ID',
    converter_data_user: 'Save to User Data',
    mapInUseWF: '<center>Mapper<br> is using at <br>Workflow.</center>',
    partnerTableWF: '<center>Partner<br> is using at <br>Workflow.</center>',
    partnerCardWF: 'Partner is using at Workflow.',
    commInUseWF: "<center>It's using at<br>Workflow<br>or Other version.</center>",
    cvtrInUseWF: "<center>It's using<br> at <br>Workflow.</center>",
    ediInUseWF: 'Using at Workflow.',
    dbBrkInUseWF: '<center>Using at<br>Converter / Workflow.</center>',
    delComponent: 'Do you want to delete this {0} from list ?',
    versionHistory: {
      title: 'Workflow Version History',
    },
    eventHistory: 'Process Setup Event History',
  },
  integrationSET: {
    page_header: 'Integration SETs',
    smartLinkTxt: 'SmartLink Standard Layout',
    messageStructure: 'Message Structure',
    itemDetails: 'Item Details',
  },
  repositoryManager: {
    page_header: 'Repository Manager',
    updateDate: 'Update Date',
  },
  flatFileLayout: {
    page_header: 'Message Layout',
    updateDate: 'Update Date',
    addFlatFile: {
      flatFile: 'FlatFile Layout',
      comment: 'Comment',
      businessName: 'Business Name',
      csvFile: 'CSV File',
      type: 'Type',
    },
    flatFileCheckIn: {
      page_header: 'FlatFile Layout Check In',
    },
    versionHistory: {
      page_header: 'FlatFile Version History',
    },
  },
  users: {
    page_header: 'Users',
    addUser: {
      header: 'User Information',
      menu: 'Menu',
      buttonRole: 'Button Role',
      userId: 'User ID',
      userName: 'User Name',
      password: 'Password',
      companyAddress: 'Company Address',
      companyName: 'Company ID',
      phone: 'Phone',
      country: 'Country',
      timeZone: 'Time Zone',
      role: 'Role',
      screenTheme: 'Screen Theme',
      search: 'Search',
      emailVerification: 'Email Verification Status',
    },
    myAccount: {
      header: 'My Account',
      userInformation: 'User Information',
      changePassword: 'Change Password',
      name: 'Name',
      phone: 'Phone',
      country: 'Country',
      timeZone: 'Time Zone',
      role: 'Role',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      screenTheme: 'Screen Theme',
    },
  },
  loginUser: {
    header: 'Login User Monitoring',
    conditionSearch: {
      userId: 'User ID',
      userIp: 'User IP',
      deviceTp: 'Device Type',
    },
  },
  report: {
    page_header: 'Report',
    dateRange: 'Date Range',
  },
  codes: {
    page_header: 'Codes',
  },
  delHistoryWorkflowDialog: {
    title: 'Warning',
  },
  admin: {
    page_header: 'Process Search',
    monitor_header: 'Monitoring',
    log_header: 'System Log',
    process_detail: 'Process Detail',
    backup_file_finder: 'Backup File Finder',
    recent_system_errors: 'Recent System Errors',
    recent_trans: 'Recent Transactions',
    processSearch: 'Process ID',
    owner: 'Owner ID : ',
    company: 'Company ID : ',
    process: 'Process ID : ',
    workflow: 'Workflow ID : ',
    workflowNm: 'Workflow Name : ',
    status: 'Status : ',
    sender: 'Sender : ',
    receiver: 'Receiver : ',
    message: 'Message : ',
    partner: 'Partner : ',
    owner_header: 'Owner ID',
    company_header: 'Company ID',
    process_header: 'Process ID',
    transaction: 'Transaction Code',
    error: 'Error Desc.',
    errorRecent: 'Error',
    dateTime: 'Date & Time',
    recentFailedTransactions: {
      page_header: 'Recent Failed Transactions',
    },
    backupFileContentView: {
      page_header: 'Backup File Content',
    },
    file_content: 'File Content',
    file_name: 'File Name',
    date_validation: 'The difference between from date and to date cannot be more than 24 hours.',
    search_event_history_validation: 'Search condition is required.',
    input_process: 'Please input Process ID !',
  },
  dataSource: {
    pageHeader: 'Data Source',
    addSrc: 'Add Data Source',
    modifySrc: 'Modify Data Source',
    form: {
      name: 'Name',
      from: 'From',
      to: 'To',
      module: 'Module',
      db: 'DB Config',
      xml: 'DB Mapper',
      sql: 'Sql Group',
      type: 'Type',
    },
    sqlGpUseInDS: '<center>Using at<br>Data Source, <br>or Deployed Status</center>',
    sqlGroup: {
      pageHeader: 'SQL Set-up',
      addSqlGroupDialog: {
        pageHeaderAdd: 'Add SQL Group',
        pageHeaderModify: 'Modify SQL Group',
        sqlGroupName: 'SQL Group',
        checkboxLabel: 'All Queries',
        codeLabelInfo: 'all queries are displayed regardless of left selected code',
        tooltipQuerySeq: 'This number is the query execution order.',
        conditionSearch: {
          queryName: 'Query Name',
          dbName: 'DB Name',
          type: 'Type',
          queryText: 'Query Text',
        },
      },
      addD2DSqlGroupDialog: {
        pageHeaderAdd: 'Add D2D SQL Group',
        pageHeaderModify: 'Modify D2D SQL Group',
      },
    },
    dbConfig: {
      title: 'DB Config',
      tableHead: {
        select: 'Select',
        name: 'DB Config Name',
        desc: 'Desc.',
        updt: 'Update Date',
        upUsr: 'Update User',
      },
      addDB: {
        dbIns: 'DB Instance',
        dbNm: 'DB Config Name',
        dbTable: 'DB Table Name',
        node: 'Node',
        live: 'Live',
        selectSql: 'Select Sql',
        doingSql: 'Doing Sql',
        doneSql: 'Done Sql',
        exSql: 'Extra Sql',
        errSql: 'Error Sql',
      },
    },
    xmlMap: {
      title: 'DB Mapper',
      tableHead: {
        select: 'Select',
        name: 'DB Mapper Name',
        type: 'Type',
        version: 'Version',
        deploy: 'Deploy Date',
        updt: 'Update Date',
        upUsr: 'Update User',
      },
    },
    sqlGrp: {
      title: 'SQL Group',
      tableHead: {
        select: 'Select',
        name: 'SQL Group',
        updt: 'Update Date',
        upUsr: 'Update User',
        no: 'No.',
        text: 'SQL Text.',
      },
    },
  },
  // 2022.05.20 213979 SLI-126 add DB Map Builder
  dbMapperTest: {
    pageHeader: 'DB Mapper Testing Tool',
    targetQuery: {
      title: 'Target Query',
      tableHead: {
        select: 'Select',
        name: 'Query Name',
        query: 'Query',
        updateDate: 'Update Date',
        updateUser: 'Update User',
      },
    },
    saveTargetQuery: {
      title: 'Save Target Query',
      queryName: 'Query Name',
      query: 'Query',
    },
    testDBConfig: {
      title: 'DB Config',
      sql: 'SQL',
      selectDBConfig: 'Select DB Config',
    },
    outputData: 'Output',
    outputJson: 'Output (JSON)',
    outputFile: 'Output (File)',
    json: 'Json (Input)',
    xmlMapper: {
      title: 'DB Mapper',
      resultTest: 'Result of Test',
    },
    xmlMapperList: {
      title: 'DB Mapper List',
      tableHead: {
        name: 'DB Mapper Name',
        xmlMapper: 'DB Mapper',
        updtUsr: 'Update User',
      },
    },
    sqlGrp: {
      sqlGrp: 'SQL Group',
      sqlGrpSource: '(Source) SQL Group',
      sqlGrpTarget: '(Target) SQL Group',
    },
    dbInstance: {
      title: 'Target DB Instance',
      selectDBInstance: 'Select DB Instance',
    },
    selectSqlGroup: {
      title: 'Select SQL Group',
      tableHead: {
        name: 'Name',
        type: 'Type',
        queryText: 'Query Text',
        sqlGroup: 'SQL Group',
        id: 'Id',
        dbType: 'DB Type',
      },
    },
    selectSqlGroupD2D: {
      tableHead: {
        type: 'Type',
        seq: 'Seq',
        st: 'S/T',
        dbInstance: 'DB Instance',
        query: 'Query',
        dbType: 'DB Type',
      },
    },
    deployDBMapper: {
      title: 'Deploy DB Mapper',
      dbMapperName: 'DB Mapper Name',
      sqlGrp: 'SQL Group',
      dbMapper: 'DB Mapper',
      comment: 'Comment',
    },
    loadFile: {
      loadFileHeader: 'Load File',
      folderSection: 'Folders',
      fileSection: 'Files',
      searchFieldPlaceHolder: 'Find by File Name',
      searchTypePlaceHolder: 'Search by',
      fileName: 'File Name',
    },
    xmlTableVersionHistory: {
      mapper: 'DB Mapper Version History',
    },
  },
  dbMapperManager: {
    pageHeader: 'DB Mapper',
    load: 'Load',
    mapLayout: {
      mapName: 'Mapper Name',
      type: 'Type',
      xmlMapper: 'DB Mapper',
      selectSQLGroup: 'Select SQL Group',
      addMap: 'Add DB Mapper',
      modifyMap: 'Modify DB Mapper',
    },
    versionHistory: {
      header: 'DB Mapper Version History',
    },
  },
  userComponent: {
    pageHeader: 'User Component',
    scriptFile: 'Script File',
    addUserComponent: {
      name: 'Name',
      type: 'Type',
      scriptFile: 'Script File',
      req: 'Request',
      res: 'Response',
    },
    versionHistory: {
      header: 'User Component Version History',
    },
  },
  userSimulator: {
    pageHeader: 'User Component Simulator',
    title: 'Script File',
    input: 'Input',
    output: 'Output',
    validDuplicateParam: 'Duplicate Request Parameter',
    scriptList: {
      title: 'Script List',
    },
    deployUserComp: {
      title: 'Deploy User Component',
      userComp: 'User Component',
    },
  },
  workflowGroup: {
    pageHeader: 'Workflow Group',
    componentNotUse: '"Folder" and "Filter" cannot be used in Workflow Group',
    versionHistory: {
      title: 'Workflow Group Version History',
    },
  },
  agents: {
    createAgent: 'Create new Agent',
    agentInfo: 'Agent Information',
    dbInfo: 'DB Information',
    agentNm: 'Name',
    agentIP: 'IP',
    port: 'Port',
    dbIns: 'DB Instance',
    table: 'Table',
  },
  veTable: {
    empty: 'No matching records found.',
  },
};
